import React from "react";
import styled from 'styled-components';
import Label from "./Label";

const TitleWrapper = styled.div`
	display: flex;
	column-gap: 8px;
	justify-content: center;
	padding-top: 10px;
`;

function Title ({
	className = "", // Add className="error" to show RED colored label.
	text = "Label",
	visible,
	verified = false,
	error = false,
	clickable = false,
	clickable_method = undefined,
	lineHeight = 1,
	...props
}) {
	return (
		<TitleWrapper>
			{/* {props.icon ? <div className="icon">
				{props.icon}
			</div> : <></>} */}
			<Label
				id="pageTitle"
				className="pageTitle"
				text={text}
				visible={visible}
				clickable={false}
				style={{
					fontSize: props?.style?.fontSize ? props?.style?.fontSize : "24px",
					color: props?.style?.color ? props?.style?.color : "#CB3443",
					fontWeight: props?.style?.fontWeight ? props?.style?.fontWeight : "700",
					fontFamily: props?.style?.fontFamily ? props?.style?.fontFamily : "pf_handbook_proregular",
					fontStyle: props?.style?.fontStyle ? props?.style?.fontStyle : "normal",
					lineHeight: props?.style?.lineHeight ? props?.style?.lineHeight : "29px",
					textAlign: props?.style?.textAlign ? props?.style?.textAlign : "center",
					padding: props?.style?.padding ? props?.style?.padding : "0px",
					...props.style
				}}
			/>
		</TitleWrapper>
	);
};
export default Title;
